@if (!isUsedInHierarchy) {
  <zn-hierarchical-view
    [rootComponentInstance]="this"
    [hideCreateButton]="true"
  />
} @else {
  <app-crud-page
    #crudPage
    [tableName]="config.localizationKey"
    [permission]="config.permission"
    [fields]="fieldsWithChevron()"
    [dataset]="dataset()"
    [loading]="loading()"
    [loadData]="loadData"
    (createRecord)="create()"
    (deleteRecord)="deleteRecords()"
    (editRow)="edit($event)"
    (saveInMemoryRequested)="onSaveInMemory($event)"
    (selectedItemsChange)="onRowSelection($event)"
    (exportToExcelRecord)="exportToExcel()"
  ></app-crud-page>
}

<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>
